export enum ConnectionViewType {
  Settings = 'settings',
  ConfigurableResources = 'configurable-resources',
  CustomMapping = 'custom-mapping',
  ConsentHistory = 'consent-history',
  ConsentScreen = 'consent-screen',
  ButtonMenu = 'button-menu',
}
